export class AvailablePackages {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get packages() {
        return this.parent;
    }
    get Edit() {
        if (!this.packages.Defer.isAvailable)
            return undefined;
        return this.packages.Edit.isAvailable ? this.packages.Edit.availablePackage : undefined;
    }
    get Abfrager() {
        return this.packages.Abfrager.isAvailable ? this.packages.Abfrager.availablePackage : undefined;
    }
    get Draft() {
        return this.packages.Draft.isAvailable ? this.packages.Draft.availablePackage : undefined;
    }
    get Defer() {
        return this.packages.Defer.isAvailable ? this.packages.Defer.availablePackage : undefined;
    }
    get Lazy() {
        return this.packages.Lazy.isAvailable ? this.packages.Lazy.availablePackage : undefined;
    }
    get Rare() {
        return this.packages.Rare.isAvailable ? this.packages.Rare.availablePackage : undefined;
    }
    get Exotic() {
        return this.packages.Exotic.isAvailable ? this.packages.Exotic.availablePackage : undefined;
    }
    get Mobile() {
        return this.packages.Mobile.isAvailable ? this.packages.Mobile.availablePackage : undefined;
    }
    get Grundschule() {
        return this.packages.Grundschule.availablePackage || undefined;
    }
    get Plugin() {
        return this.packages.Plugin.isAvailable ? this.packages.Plugin.availablePackage : undefined;
    }
    get Layout() {
        return this.packages.Layout.isAvailable ? this.packages.Layout.availablePackage : undefined;
    }
    get Large() {
        return this.packages.Large.isAvailable ? this.packages.Large.availablePackage : undefined;
    }
    get Multi() {
        return this.packages.Multi.isAvailable ? this.packages.Multi.availablePackage : undefined;
    }
    get EditLazy() {
        return this.packages.EditLazy.isAvailable ? this.packages.EditLazy.availablePackage : undefined;
    }
    get allAvailablePackages() {
        return this.packages.allPackages.filter((p) => p.isAvailable);
    }
}
